module.exports = __webpack_public_path__ + "static/10-e234690e51167d4f5c84643476ab500d.jpg";